import { COLOR_PALETTE } from '@shared/constants/theme.constants'

export const getPaletteColor = (color: string) =>
  COLOR_PALETTE.find(({ name }) => name === color) || COLOR_PALETTE[0]
